import React from 'react';
import Modal from 'components/shared/Modal/Modal';
import ConfigParamsSettingsTable from '../ConfigParamSettingsTable/ConfigParamSettingsTable';
import WarningBox from 'components/shared/WarningBox/WarningBox';
import { TWO_HOP_ALIGNMENT_SCREEN_INDEXES } from '../utils';

import './TwoHopSettings.css';

const WARNING_MESSAGES = [
  'Selecting full Dither may take up over 9 hours to complete.',
  'Recommended Dither Defaults create 17 Heatmaps and may take up to 60 minutes to complete. Dither of 0 degree elevation is recommended because of 25 deg elevation antenna beamwidth.'
];

const TwoHopSettings = (props) => {
  const { settingsData, requestStatus, onSave, advancedSettingsOnClick, startAlignmentOnCLick } = props;

  return (
    <Modal
      animateX={false}
      hideCloseButton={true}
      className={'paramSettingModal'}
      height={'fit-content'}
      width={893}
      displayFlex={true}
      overflow={true}
    >
      <div className="TwoHopSettingsContainer">
        <div className="TwoHopSettingsHeaderContainer">
          <div className="TwoHopSettingsHeaderContainer_HeaderText">Alignment Configuration</div>
          <div
            className="TwoHopSettingsHeaderContainer_AdvancedSettings"
            onClick={() => advancedSettingsOnClick(TWO_HOP_ALIGNMENT_SCREEN_INDEXES.ADVANCED_SETTINGS)}
          >
            Advanced settings
          </div>
        </div>
        <div className="TwoHopSettingsWarningContainer">
          <WarningBox warningMessages={WARNING_MESSAGES} />
        </div>
        <div className="TwoHopSettingsTableParentContainer">
          <div className="TwoHopSettingsTableHeaderContainer">
            <div className="TwoHopSettingsTableHeaderText">{settingsData?.title || 'Parameters'}</div>
            <div className="TwoHopSettingsTableSubHeaderText">Data Source - Calculated</div>
          </div>
          <ConfigParamsSettingsTable
            requestStatus={requestStatus}
            data={settingsData}
            itemName={'PIVOT1 SU1 HBF'}
            onApply={onSave}
          />
        </div>
        <div className="TwoHopSettingsBottomContainer">
          <button className="TwoHopSettingsBottom_Cancel" onClick={props.onClose}>
            Cancel
          </button>
          <button onClick={startAlignmentOnCLick} className="TwoHopSettingsBottom_Run">
            Start Alignment
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default TwoHopSettings;
